import React from 'react'
import config from '../../../../config/config';
import { useIsDesktop } from '../../../../hooks/index';
import './AboutOurNfts.scss';

const AboutOurNfts = () => {
    const isDesktop = useIsDesktop();
    return (
        <div className="about-our-nfts-component">
            <div className="about-our-nfts-component__container">
                <h2>ABOUT OUR NFTS</h2>

                {config.aboutOurNftsList.map(nftData => <NftSection key={nftData.title} nftData={nftData} />)}
            </div>

            <img src={require('../../../../images/layout/stripe-down.svg').default} alt="strip" />
            {isDesktop ? 
                <img src={require('../../../../images/layout/stripe-down.svg').default} alt="stripe" /> : 
                <img src={require('../../../../images/layout/stripe-down-mobile.svg').default} alt="stripe" /> }
        </div>
    )
}

const NftSection = ({nftData: {title, author, authorImage, description, fileData: { fileName, dimensions, size, type, createTime }}}) => {
    const isDesktop = useIsDesktop();
    const renderAuthor = () => {
        return <> 
            <h3 className="nft-card-title">{title}</h3>
            
            {author && <div className="nft-section-component__container--content-author">
                <div></div>
                <span>Created by {author}</span>
            </div> }
        </>
    }

    return (
        <div className="nft-section-component">
            <div className="nft-section-component__container">
                {!isDesktop && renderAuthor()}
                {fileName && <div className="nft-section-component__container--img">
                    <img src={require(`../../../../images/nfts/${fileName}`).default} alt={title} />
                    {author && <div className="created-by-text">
                        Created by SuperFarm
                    </div> }
                </div> }

                <div className="nft-section-component__container--content">
                    {isDesktop && renderAuthor()}
                    <p>{description}</p>

                    {size && <div className="nft-section-component__container--content-file">
                        <span>File: {size} - {dimensions} - {type} - Releas Date: {new Date(createTime).toLocaleDateString()}</span>
                    </div> }
                </div>
            </div>
        </div>
    )
}

export default AboutOurNfts;